import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type TextParagraph from './text-paragraph.vue'
import type Text from './text.vue'

export const textProps = buildProps({
  level: {
    type: Number,
    default: 6,
  },
  // 是否开启溢出隐藏
  isEllipsis: {
    type: Boolean,
    default: false,
  },
  // 最多显示的行数
  rows: {
    type: Number,
    default: 1,
  },
  // 是否显示提示信息
  showTooltip: {
    type: Boolean,
    default: true,
  },
  // 是否可展开
  expandable: {
    type: Boolean,
    default: true,
  },
  // 展开描述文案
  symbol: {
    type: String,
  },
} as const)

// 段落
export const textParagraphProps = buildProps({
  // 是否开启溢出隐藏
  isEllipsis: {
    type: Boolean,
    default: false,
  },
  // 最多显示的行数
  rows: {
    type: Number,
    default: 1,
  },
  // 是否显示提示信息
  showTooltip: {
    type: Boolean,
    default: true,
  },
  // 是否可展开
  expandable: {
    type: Boolean,
    default: true,
  },
  // 展开描述文案
  symbol: {
    type: String,
  },
} as const)

// props
export type TextProps = ExtractPropTypes<typeof textProps>
export type TextParagraphProps = ExtractPropTypes<typeof textParagraphProps>

// instance
export type TextInstance = InstanceType<typeof Text>
export type TextParagraphInstance = InstanceType<typeof TextParagraph>
